import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Method } from './components/Method';
import { Bonuses } from './components/Bonuses';
import { LaunchPrice } from './components/LaunchPrice';
import { Pricing } from './components/Pricing';
import { ProComparison } from './components/ProComparison';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
export function App() {
  return <div className="min-h-screen w-full bg-ink-950 font-sans text-bone" data-id="element-0" data-mp="28suumo7jhzm9">
      <TopBar data-id="element-1" data-mp="23w4drynwuzzs" />
      <Hero data-id="element-2" data-mp="23ujk0b9f7l2z" />
      <main data-id="element-3" data-mp="23utadzydnu97">
        <StatsBar data-id="element-4" data-mp="23t8i6gzjcnei" />
        <Testimonials data-id="element-5" data-mp="3ijxqiu0iq6lh" />
        <Problem data-id="element-6" data-mp="3ikh5c1uvgeva" />
        <Method data-id="element-7" data-mp="3iiwaeb4natww" />
        <Bonuses data-id="element-8" data-mp="3ijfunyhrpue3" />
        <LaunchPrice data-id="element-9" data-mp="3ihv1ac76whht" />
        <Pricing data-id="element-10" data-mp="3mlawr57iwbsx" />
        <ProComparison data-id="element-11" data-mp="3mkrdnl64zhdb" />
        <Guarantee data-id="element-12" data-mp="3mk84otygs3bf" />
        <Faq data-id="element-13" data-mp="3mjpyp5m02aqb" />
        <CostOfInaction data-id="element-14" data-mp="3mj6k9yvk64h1" />
        <FinalCta data-id="element-15" data-mp="3rbra6pbcfxfa" />
      </main>
      <Footer data-id="element-16" data-mp="3rdkg22e4udm8" />
      <StickyBuyBar data-id="element-17" data-mp="3rd1all5o5hp3" />
    </div>;
}